

import React, { memo } from 'react';
import SVG from 'react-inlinesvg';
import { Text } from '../../../ui-kit';
import { GetInTouchImage } from '../../../assets/images';



function GetInTouchSubmitted() {
  return (
    <>
      <Text heading3>Great, Thanks!</Text>
      <Text heading4>Someone will get back to you soon!</Text>
      <SVG cacheRequests src={GetInTouchImage} title="Get In Touch" className="submitted-image" />
      <Text>You should get a response within 24- 36 hours</Text>
    </>);

}

export default memo(GetInTouchSubmitted);